var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "related-form" },
    [
      _c("TabHeaderComponent", {
        attrs: { buttons: _vm.buttons, title: _vm.getTitle },
        on: {
          closeForm: _vm.onCloseForm,
          saveForm: _vm.onSaveForm,
          removeRelated: _vm.onRemoveRelated,
        },
      }),
      _c("FormGeneratorComponent", {
        attrs: {
          schema: _vm.relatedFormFieldsParsed,
          fieldValues: _vm.formFieldsDataParsed,
          context: _vm.context,
          permissionsEntity: _vm.permissionsEntityProp,
        },
        on: { saveFormData: _vm.onSaveFormData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }